import * as $ from 'jquery';
import 'bootstrap';
import * as Slideout from 'slideout';

export class enrichSideMenu {
	$scope: any = $('#menuenrich-header');
	$navbarToggle: any = $('#menuenrich-header .navbar-toggle');
	$memberContents: any = $('#enrich-content');
    init():any{
        $('.sidebar-menu--level-1>li>.sidebar-menu-link').each(function(){
            if($(this).parent().find('input[name="has_url_configured"]').val()=='true'){
                $(this).removeAttr('data-toggle');
                $(this).find('.fa-angle-down').css('visibility', 'hidden');
                return;
            }
        })
        
			$('.sidebar-menu-link').on('click', function () {
				if ($(this).attr("role") === "button") {
					if ($(this).parent().parent().hasClass('sidebar-menu--level-2')) {
						$(this).parent().parent().collapse('show');
						$('ul .members__menu.sidebar-menu--level-2').not($(this).parent().parent()).collapse('hide');
						$('ul .members__menu.sidebar-menu--level-3').collapse('hide');
					}else if($(this).parent().parent().hasClass('sidebar-menu--level-3')){
						$(this).parent().parent().collapse('show');
						$('ul .members__menu.sidebar-menu--level-3').not($(this).parent().parent()).collapse('hide');
						$('ul .members__menu.sidebar-menu--level-4').collapse('hide');
					}
					else {
						$('ul .members__menu.sidebar-menu--level-2').collapse('hide');
						$('ul .members__menu.sidebar-menu--level-3').collapse('hide');
						$('ul .members__menu.sidebar-menu--level-4').collapse('hide');
					}
				}
			});

    }
}

let scope: Element = document.querySelector('.mob-enrich-menu-right');
if (scope) {
	try {
		let enrichSidemenu = new enrichSideMenu();
		enrichSidemenu.init();
	} catch (e) { console.error(e); }
}